import {IS_NG} from 'core/constants/env';

// export enum CATEGORY_CODES {
//     S = 'S',
//     AE = 'AE',
//     E = 'E',
//     Z = 'Z',
//     G = 'G',
//     O = 'O',
//     K = 'K',
// }

export const CAR_TAXES = [
    {value: 'S', label: 'S - Standard rate'},
    {value: 'AE', label: 'AE - option'},
    {value: 'E', label: 'E - option'},
    {value: 'Z', label: 'Z - option'},
    {value: 'G', label: 'G - option'},
    {value: 'O', label: 'O - option'},
    // {value: 'K', label: 'K - option'},
];

export const NG_TAXES = [
    {
        label: 'Standard Value-Added Tax',
        peppolValue: 'S',
        value: 'STANDARD_VAT',
    },
    {
        label: 'Reduced Value-Added Tax',
        peppolValue: 'S',
        value: 'REDUCED_VAT',
    },
    {
        label: 'Zero Value-Added Tax',
        peppolValue: 'Z',
        value: 'ZERO_VAT',
    },
    {
        label: 'Standard Goods and Services Tax',
        peppolValue: 'S',
        value: 'STANDARD_GST',
    },
    {
        label: 'Reduced Goods and Services Tax',
        peppolValue: 'S',
        value: 'REDUCED_GST',
    },
    {
        label: 'Zero Goods and Services Tax',
        peppolValue: 'Z',
        value: 'ZERO_GST',
    },
    {
        label: 'State Sales Tax',
        peppolValue: 'S',
        value: 'STATE_SALES_TAX',
    },
    {
        label: 'Local Sales Tax',
        peppolValue: 'S',
        value: 'LOCAL_SALES_TAX',
    },
    {
        label: 'Alcohol Excise Tax',
        peppolValue: 'S',
        value: 'ALCOHOL_EXCISE_TAX',
    },
    {
        label: 'Tobacco Excise Tax',
        peppolValue: 'S',
        value: 'TOBACCO_EXCISE_TAX',
    },
    {
        label: 'Fuel Excise Tax',
        peppolValue: 'S',
        value: 'FUEL_EXCISE_TAX',
    },
    {
        label: 'Corporate Income Tax',
        peppolValue: 'S',
        value: 'CORPORATE_INCOME_TAX',
    },
    {
        label: 'Personal Income Tax',
        peppolValue: 'S',
        value: 'PERSONAL_INCOME_TAX',
    },
    {
        label: 'Social Security Tax',
        peppolValue: 'S',
        value: 'SOCIAL_SECURITY_TAX',
    },
    {
        label: 'Medicare Tax',
        peppolValue: 'S',
        value: 'MEDICARE_TAX',
    },
    {
        label: 'Real Estate Tax',
        peppolValue: 'S',
        value: 'REAL_ESTATE_TAX',
    },
    {
        label: 'Personal Property Tax',
        peppolValue: 'S',
        value: 'PERSONAL_PROPERTY_TAX',
    },
    {
        label: 'Carbon Tax',
        peppolValue: 'S',
        value: 'CARBON_TAX',
    },
    {
        label: 'Plastic Tax',
        peppolValue: 'S',
        value: 'PLASTIC_TAX',
    },
    {
        label: 'Import Duty',
        peppolValue: 'S',
        value: 'IMPORT_DUTY',
    },
    {
        label: 'Export Duty',
        peppolValue: 'S',
        value: 'EXPORT_DUTY',
    },
    {
        label: 'Luxury Tax',
        peppolValue: 'S',
        value: 'LUXURY_TAX',
    },
    {
        label: 'Service Tax',
        peppolValue: 'S',
        value: 'SERVICE_TAX',
    },
    {
        label: 'Tourism Tax',
        peppolValue: 'S',
        value: 'TOURISM_TAX',
    },
];

export function splitValue(value: string) {
    return value.split(' :: ')[0];
}

export const isStandartCategory = (value: string | undefined) => {
    if (!value) {
        return false;
    }

    if (IS_NG) {
        const item = NG_TAXES.find((i) => i.value === splitValue(value));
        return item ? item.peppolValue === 'S' : false;
    }

    return splitValue(value) === 'S';
};

export const isZeroCategory = (value: string | undefined) => {
    if (!value) {
        return false;
    }

    if (IS_NG) {
        const item = NG_TAXES.find((i) => i.value === splitValue(value));
        return item ? item.peppolValue === 'Z' : false;
    }

    return splitValue(value) === 'Z';
};

export const ifCategoryOfO = (value: string | undefined) => {
    if (IS_NG || !value) {
        return false;
    }
    return splitValue(value) === 'O';
};

export const VAT_CATEGORY = IS_NG ? NG_TAXES : CAR_TAXES;

export const toDisplayTaxCategory = (value: string) =>
    VAT_CATEGORY.find((i) => i.value === splitValue(value))?.label;
